import * as React from "react";

function SvgOverflow(props) {
  return <svg width="1em" height="1em" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.888 2.544a2.52 2.52 0 105.04 0 2.52 2.52 0 00-5.04 0zM9.888 12.024a2.52 2.52 0 105.04 0 2.52 2.52 0 00-5.04 0zM9.888 21.48a2.52 2.52 0 105.04 0 2.52 2.52 0 00-5.04 0z" /></svg>;
}

export default SvgOverflow;